<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="12" md="10" lg="8">
        <v-card>
          <v-card-title>
            <v-icon left>fas fa-heartbeat</v-icon>
            Quality Control Data
          </v-card-title>
          <QualityCoatedMeasurementTable :is-detailed="false" :measurements="measurements" :loading="false" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// TODO Update Table for aesthetic appearance
import { BatchMeasurement } from "../../models/Measurement";
import QualityCoatedMeasurementTable from "../../components/Quality/QualityCoatedMeasurementTable";
export default {
  name: "ProjectQualityListView",
  components: { QualityCoatedMeasurementTable },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    measurements() {
      return BatchMeasurement.query()
        .whereHas("batch", (query => {
          query.where("project", parseInt(this.id))
        }))
        .with("batch")
        .get();
    }
  }
}
</script>
